const PHONE = "5521995654639";

const MESSAGES = {
    geral: "Olá! Conheci a LC Production pelo site e gostaria de receber informações para o meu evento.",
    cerimonial:
        "Olá! Conheci a LC Cerimonial pelo site da LC Production e gostaria de receber informações para o meu evento.",
    astrolive:
        "Olá! Conheci a AstroLive pelo site da LC Production e gostaria de receber informações sobre a experiência para minha festa.",
    promo:
        "Olá! Vi no site a condição especial de até 20% de desconto da LC Production e gostaria de aproveitar antes que acabe.",
};

export const waLink = (origin = "geral") =>
    `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGES[origin] || MESSAGES.geral)}`;
